import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IApiCompanyFilter, IApiCompanyFilterType, IApiSageClass } from 'src/app/shared/modules/graphql/types/types';

@Component({
  selector: 'app-bookkeeping-company-filter',
  templateUrl: './bookkeeping-company-filter.component.html',
  styleUrls: ['./bookkeeping-company-filter.component.scss']
})
export class BookkeepingCompanyFilterComponent {

  public readonly companyKey = 'classId';

  public operators = [
    { text: 'In', value: '$in' },
    { text: 'Not In', value: '$notIn' }
  ];

  @Input() public operator: '$in' | '$notIn' = '$in';
  @Output() public operatorChange = new EventEmitter<'$in' | '$notIn'>();

  /** Tracks currently selected company IDs (for binding back to the multiselect) */
  @Input() public selectedCompanyIds: string[] = [];
  @Output() public selectedCompanyIdsChange = new EventEmitter<string[]>();

  @Input() public companyFilters: IApiCompanyFilter[] = [
    {
      type: IApiCompanyFilterType.HasSageKey,
      value: 'true'
    }
  ];

  @Output() public filterChange = new EventEmitter<string | null>();
  @Output() public enterPressed = new EventEmitter<void>();

  public onOperatorChange(newVal: '$in' | '$notIn'): void {
    this.operator = newVal;
    this.operatorChange.emit(newVal);
    this._emitFilter();
  }

  public onSelectionChanged(ids: string[]): void {
    this.selectedCompanyIds = ids ?? [];
    this.selectedCompanyIdsChange.emit(this.selectedCompanyIds);
  }

  public onSageClassesChanged(sageClasses: IApiSageClass[]): void {
    this.selectedCompanyIds = (sageClasses || []).map(sageClass => sageClass.id).filter((id): id is string => !!id);
    this.selectedCompanyIdsChange.emit(this.selectedCompanyIds);
    this._emitFilter();
  }

  public onEnterPressed(): void {
    this.enterPressed.emit();
  }

  /** Emits filter using company IDs:
   *  {"$in":{"customer.contacts.default.companyId":["company-123"]}}
   *  {"$notIn":{"customer.contacts.default.companyId":["company-123"]}}
   */
  private _emitFilter(): void {
    if (this.selectedCompanyIds?.length > 0) {
      const filterValue = JSON.stringify({
        [this.operator]: { [this.companyKey]: this.selectedCompanyIds }
      });
      this.filterChange.emit(filterValue);
    } else {
      this.filterChange.emit(null);
    }
  }
}
